import React from 'react'

const EnableDisableTag = ({ enabled = false }) => {
  const tagClasses = enabled ? 'bg-ds-green-100 text-ds-green-500' : 'bg-gray-200 text-gray-600'
  return (
    <div className={`rounded-ds-pill py-1 px-3 h-7 text-xs font-semibold flex justify-center items-center gap-1 ${tagClasses}`}>
      <span className={`block rounded-full p-1 ${enabled ? 'bg-ds-green-400' : 'bg-gray-500'}`}></span>
      { enabled ? 'Enabled' : 'Disabled' }
    </div>
  )
}

export default EnableDisableTag